
import { ILocation } from "@/types";
import { computed, defineComponent } from "vue";
import MapMarker from "@/components/map/MapMarker.vue";
import { useLocation } from "@/services";
import { createLocationInstance } from "@/util/locationFactory";
export default defineComponent({
  components: { MapMarker },
  props: {
    location: {
      type: Object as () => ILocation,
      required: true,
    },
  },
  setup(props) {
    const locationInfo = computed(() => createLocationInstance(props.location));
    function loadLocation() {
      useLocation().updateLocation(props.location as ILocation, true);
    }

    function remove() {
      useLocation().remove(props.location);
    }

    return { locationInfo, remove, loadLocation };
  },
});
